import { render, staticRenderFns } from "./LayoutUser.vue?vue&type=template&id=721a9546&scoped=true"
import script from "./LayoutUser.vue?vue&type=script&lang=js"
export * from "./LayoutUser.vue?vue&type=script&lang=js"
import style0 from "./LayoutUser.vue?vue&type=style&index=0&id=721a9546&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6554cb098e537a9b8e01f1854c0c52c1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721a9546",
  null
  
)

export default component.exports